import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { provideHttpClient } from '@angular/common/http';
import { ComponentsRoutingModule } from '../components/components-routing.module';
import { DotNavigationModule } from '@wuitk/angular/components/dot-navigation';
import { CarouselModule } from '@wuitk/angular/components/carousel';
import { ButtonModule } from '@wuitk/angular/components/button';
import { ComponentsModule } from '../components/components.module';
import { RouterModule } from '@angular/router';
import { GridViewModule } from '@wuitk/angular/components/grid-view';
import { CommonModule as DLSCommonModule} from '@wuitk/angular/components/common';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [DashboardComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, ComponentsRoutingModule, DotNavigationModule, CarouselModule, ButtonModule,ComponentsModule, RouterModule, GridViewModule, DLSCommonModule, SharedModule ],
  providers: [provideHttpClient(), Location]
})
export class DashboardModule { }
